export function parseArrayToString(value: any[]) {
  return value.map((v) => v.toString()).join(', ');
}

export function parseDateToString(value: any) {
  if (value.isLuxonDateTime) {
    return `${value.toFormat('yyyy-LL-dd')}T${value.toFormat('HH:mm')}${value.toFormat('ZZ')}`;
  }

  return value.toString();
}
